import { get, post } from './apiService';

export interface RetellVoice {
  voice_id: string;
  voice_name: string;
  provider?: string;
  accent?: string;
  gender?: string;
}

export async function getRetellPhoneNumbers(): Promise<string[]> {
  return get<string[]>('/retell/agent/phone');
}

export async function getRetellVoices(): Promise<RetellVoice[]> {
  return get<RetellVoice[]>('/retell/agent/voices');
}

export interface CreateRetellCallPayload {
  fromNumber: string;
  toNumber: string;
  retellAgentId: string;
  propertyId: string;
  timezone: string;
  voiceId: string;
  retellCallReportId: string | null;
  data: Record<string, string>[];
  callDate?: string;
  callDateTimezone?: string;
  callType?: 'on-demand' | 'scheduled';
}

export async function createRetellCall(data: CreateRetellCallPayload): Promise<{ id: string }> {
  return post<{ id: string }>('/retell/agent/call', data);
}
